/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PromoTokenType } from './PromoTokenType';
import {
    PromoTokenTypeFromJSON,
    PromoTokenTypeFromJSONTyped,
    PromoTokenTypeToJSON,
    PromoTokenTypeToJSONTyped,
} from './PromoTokenType';

/**
 * 
 * @export
 * @interface PromoTokenBody
 */
export interface PromoTokenBody {
    /**
     * 
     * @type {string}
     * @memberof PromoTokenBody
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PromoTokenBody
     */
    description?: string;
    /**
     * 
     * @type {PromoTokenType}
     * @memberof PromoTokenBody
     */
    type: PromoTokenType;
    /**
     * 
     * @type {boolean}
     * @memberof PromoTokenBody
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PromoTokenBody
     */
    isBranded?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PromoTokenBody
     */
    targetUrl?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PromoTokenBody
     */
    couponCodes?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PromoTokenBody
     */
    qrImageUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof PromoTokenBody
     */
    expiresAt?: number;
    /**
     * 
     * @type {number}
     * @memberof PromoTokenBody
     */
    maxLimit?: number;
    /**
     * 
     * @type {string}
     * @memberof PromoTokenBody
     */
    apiEndpoint?: string;
    /**
     * 
     * @type {string}
     * @memberof PromoTokenBody
     */
    apiKeyRef?: string;
    /**
     * 
     * @type {object}
     * @memberof PromoTokenBody
     */
    apiPayloadTemplate?: object;
    /**
     * 
     * @type {string}
     * @memberof PromoTokenBody
     */
    loyaltyPartnerId?: string;
    /**
     * 
     * @type {number}
     * @memberof PromoTokenBody
     */
    pointsToAward?: number;
    /**
     * 
     * @type {string}
     * @memberof PromoTokenBody
     */
    loyaltyApiEndpoint?: string;
    /**
     * 
     * @type {string}
     * @memberof PromoTokenBody
     */
    loyaltyApiKeyRef?: string;
    /**
     * 
     * @type {string}
     * @memberof PromoTokenBody
     */
    requiredLinkedAccount?: string;
}



/**
 * Check if a given object implements the PromoTokenBody interface.
 */
export function instanceOfPromoTokenBody(value: object): value is PromoTokenBody {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function PromoTokenBodyFromJSON(json: any): PromoTokenBody {
    return PromoTokenBodyFromJSONTyped(json, false);
}

export function PromoTokenBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PromoTokenBody {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'type': PromoTokenTypeFromJSON(json['type']),
        'isEnabled': json['isEnabled'] == null ? undefined : json['isEnabled'],
        'isBranded': json['isBranded'] == null ? undefined : json['isBranded'],
        'targetUrl': json['targetUrl'] == null ? undefined : json['targetUrl'],
        'couponCodes': json['couponCodes'] == null ? undefined : json['couponCodes'],
        'qrImageUrl': json['qrImageUrl'] == null ? undefined : json['qrImageUrl'],
        'expiresAt': json['expiresAt'] == null ? undefined : json['expiresAt'],
        'maxLimit': json['maxLimit'] == null ? undefined : json['maxLimit'],
        'apiEndpoint': json['apiEndpoint'] == null ? undefined : json['apiEndpoint'],
        'apiKeyRef': json['apiKeyRef'] == null ? undefined : json['apiKeyRef'],
        'apiPayloadTemplate': json['apiPayloadTemplate'] == null ? undefined : json['apiPayloadTemplate'],
        'loyaltyPartnerId': json['loyaltyPartnerId'] == null ? undefined : json['loyaltyPartnerId'],
        'pointsToAward': json['pointsToAward'] == null ? undefined : json['pointsToAward'],
        'loyaltyApiEndpoint': json['loyaltyApiEndpoint'] == null ? undefined : json['loyaltyApiEndpoint'],
        'loyaltyApiKeyRef': json['loyaltyApiKeyRef'] == null ? undefined : json['loyaltyApiKeyRef'],
        'requiredLinkedAccount': json['requiredLinkedAccount'] == null ? undefined : json['requiredLinkedAccount'],
    };
}

export function PromoTokenBodyToJSON(json: any): PromoTokenBody {
    return PromoTokenBodyToJSONTyped(json, false);
}

export function PromoTokenBodyToJSONTyped(value?: PromoTokenBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'type': PromoTokenTypeToJSON(value['type']),
        'isEnabled': value['isEnabled'],
        'isBranded': value['isBranded'],
        'targetUrl': value['targetUrl'],
        'couponCodes': value['couponCodes'],
        'qrImageUrl': value['qrImageUrl'],
        'expiresAt': value['expiresAt'],
        'maxLimit': value['maxLimit'],
        'apiEndpoint': value['apiEndpoint'],
        'apiKeyRef': value['apiKeyRef'],
        'apiPayloadTemplate': value['apiPayloadTemplate'],
        'loyaltyPartnerId': value['loyaltyPartnerId'],
        'pointsToAward': value['pointsToAward'],
        'loyaltyApiEndpoint': value['loyaltyApiEndpoint'],
        'loyaltyApiKeyRef': value['loyaltyApiKeyRef'],
        'requiredLinkedAccount': value['requiredLinkedAccount'],
    };
}

